import React from 'react';
import { Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import styles from './signature.scss';
export function SignatureUpload(props) {
  const {
    label,
    value,
    onChange
  } = props;
  const $input = React.useRef(null);
  if (value) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    priority: ButtonPriority.primary
  }, label), /*#__PURE__*/React.createElement("input", {
    accept: "image/*",
    type: "file",
    tabIndex: -1,
    ref: $input,
    onChange: handleChange,
    className: styles.hiddenInput
  }));
  function handleClick() {
    var _$input$current;
    (_$input$current = $input.current) == null || _$input$current.click();
  }
  function handleChange(event) {
    const fileReader = new FileReader();
    const [file] = event.target.files || [];
    if (!file) {
      return;
    }
    fileReader.onload = function () {
      onChange(this.result);
    };
    fileReader.readAsDataURL(file);
    event.target.value = '';
  }
}
//# sourceMappingURL=signature-upload.js.map